
import {
  benefits,
  solutions,
  managedKuber,
  popularServices,
  questions,
} from "~/data/kubernetes";
import Modal from "../../components/rebranding/modal/Modal.vue";

export default {
  data() {
    return {
      title: "سرویس کوبرنتیز آبالون | مدیریت آسان کلاستر‌های کانتینری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      benefits,
      solutions,
      managedKuber,
      popularServices,
      questions,
      activeSection: "",
      tab: 0,
      solotionTab: 0,
      showmore: false,
    };
  },
  components: {
    Modal,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "سرویس کوبرنتیز آبالون | مدیریت آسان کلاستر‌های کانتینری",
      meta: [
        {
          name: "description",
          content:
            "کوبرنتیز مدیریت‌ شده آبالون | اجرای امن و پایدار اپلیکیشن‌های کانتینری | مقیاس‌پذیری بالا | استقرار سریع روی زیرساخت ابری و داخلی",
        },
        {
          name: "keywords",
          content: "کوبرنتیز آبالون, کوبرنتیز مدیریت‌ شده, سرویس کوبرنتیز",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/kubernetes",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "سرویس کوبرنتیز آبالون | مدیریت آسان کلاستر‌های کانتینری",
        },
        {
          property: "og:description",
          content:
            "کوبرنتیز مدیریت‌ شده آبالون | اجرای امن و پایدار اپلیکیشن‌های کانتینری | مقیاس‌پذیری بالا | استقرار سریع روی زیرساخت ابری و داخلی",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/kubernetes",
        },
        {
          name: "twitter:title",
          title: "سرویس کوبرنتیز آبالون | مدیریت آسان کلاستر‌های کانتینری",
        },
        {
          name: "twitter:description",
          content:
            "کوبرنتیز مدیریت‌ شده آبالون | اجرای امن و پایدار اپلیکیشن‌های کانتینری | مقیاس‌پذیری بالا | استقرار سریع روی زیرساخت ابری و داخلی",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/kubernetes",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "سرویس کوبرنتیز مدیریت‌شده آبالون چه مزایایی نسبت به راهکارهای سنتی زیرساختی دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "کوبرنتیز مدیریت‌شده آبالون پیچیدگی‌های فنی در استقرار و مدیریت کلاسترها را حذف می‌کند و بستری پایدار و انعطاف‌پذیر برای اجرای اپلیکیشن‌های سازمانی فراهم می‌سازد. این سرویس با کاهش بار مدیریتی تیم‌های فنی، زمان و هزینه نگه‌داری زیرساخت را به حداقل می‌رساند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا می‌توان کلاسترهای کوبرنتیز (k8s) را روی زیرساخت‌های داخلی سازمان (On-Premise) نیز اجرا کرد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. کوبرنتیز مدیریت‌شده آبالون هم روی دیتاسنترهای ابری آبالون و هم روی زیرساخت داخلی سازمان (On-Premise) قابل استقرار است. همچنین امکان پیاده‌سازی در مدل ابر ترکیبی (Hybrid Cloud) وجود دارد.",
                },
              },
              {
                "@type": "Question",
                name: "چگونه امنیت داده‌ها و ارتباطات در کوبرنتیز مدیریت‌شده آبالون تضمین می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "این سرویس با رمزنگاری داده‌ها، مانیتورینگ مداوم، به‌روزرسانی‌های امنیتی منظم و معماری مقاوم در برابر اختلال، امنیت و پایداری کلاسترها را تضمین می‌کند. علاوه بر این، کنترل دسترسی پیشرفته امکان مدیریت دقیق کاربران و سطح دسترسی آن‌ها را فراهم می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا سرویس کوبرنتیز آبالون از منابع سخت‌افزاری متنوع پشتیبانی می‌کند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. این سرویس امکان استفاده از منابع اختصاصی مانند CPU، RAM و فضای ذخیره‌سازی را متناسب با نیاز سازمان فراهم می‌کند. در صورت تغییر نیازمندی‌ها، منابع به‌سادگی و از طریق تیم پشتیبانی آبالون قابل افزایش یا کاهش هستند.",
                },
              },
            ],
          },
        },
      ],
    };
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
};
